import { lazy, Suspense, useCallback } from "react";
import { useNavigate, useRouterState } from "@tanstack/react-router";

const FeedbackModalLazy = lazy(
  () => import("@/components/feedback/FeedbackModal"),
);

/** Read the `feedback` search param off whatever route is currently rendered. */
function useFeedbackSearchOpen(): boolean {
  return useRouterState({
    select: (state) => {
      const search = state.location.search as Record<string, unknown>;
      return search?.feedback === "open";
    },
  });
}

export default function FeedbackModalRoot() {
  const open = useFeedbackSearchOpen();
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    void navigate({
      to: ".",
      search: (current: Record<string, unknown>) => {
        const next = { ...current };
        delete next.feedback;
        return next;
      },
      replace: true,
    });
  }, [navigate]);

  if (!open) return null;

  return (
    <Suspense fallback={null}>
      <FeedbackModalLazy open={open} onClose={handleClose} />
    </Suspense>
  );
}
